import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { SelectionReply } from '@/http/workflowTask';
import { Handle, NodeProps, Position } from '@vue-flow/core';
import Input from '@/components/ui/input/Input.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListReplyOptionNode',
  props: {
    id: {},
    type: {},
    selected: { type: Boolean },
    connectable: { type: [Boolean, Number, String, Function] },
    position: {},
    dimensions: {},
    label: {},
    isValidTargetPos: { type: Function },
    isValidSourcePos: { type: Function },
    parent: {},
    parentNodeId: {},
    dragging: { type: Boolean },
    resizing: { type: Boolean },
    zIndex: {},
    targetPosition: {},
    sourcePosition: {},
    dragHandle: {},
    data: {},
    events: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Input, {
        "model-value": props.data.title,
        readonly: true,
        class: "w-[12.5rem]"
      }, null, 8, ["model-value"])
    ]),
    _createVNode(_unref(Handle), {
      id: `${props.data.id}_R`,
      type: "source",
      position: _unref(Position).Right
    }, null, 8, ["id", "position"])
  ], 64))
}
}

})